var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLolIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4433_5771",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H0V12H12V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4433_5771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.722647 3.65625C0.262059 4.43879 0 5.33493 0 6.28787C0 7.24081 0.262059 8.13778 0.722647 8.92031V3.65625Z",
    fill: "#C79B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00024 0.758057C5.51348 0.758057 5.04113 0.813204 4.58789 0.913296V1.78352C5.03671 1.66495 5.50995 1.59988 6.00024 1.59988C8.80907 1.59988 11.0864 3.69216 11.0864 6.27359C11.0864 7.43609 10.6232 8.49932 9.85877 9.31716L9.71377 9.79418L9.39289 10.85C10.9676 9.85346 12.0011 8.18223 12.0011 6.28903C12.0002 3.23361 9.31407 0.758057 6.00024 0.758057Z",
    fill: "#C79B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58789 9.15747H9.18995H9.29054C10.0694 8.40747 10.5491 7.39194 10.5491 6.27356C10.5491 3.9651 8.51289 2.09424 6.00054 2.09424C5.5073 2.09424 5.03318 2.16786 4.58818 2.30049V9.15747H4.58789Z",
    fill: "#C79B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04353 0H0.619995L1.26647 1.23695V10.7639L0.619995 12H8.47676L9.18941 9.65901H4.04353V0Z",
    fill: "#C79B3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLolIcon);
export default __webpack_public_path__ + "static/media/lol-icon.dd326dd43af631a43a0cff1add9ea8c1.svg";
export { ForwardRef as ReactComponent };